// @ts-ignore
import Keycloak from 'keycloak-js';
import envConfig from "../utils/EnvConfig";

const keycloak = new Keycloak({
    url: envConfig.keycloakServer,
    realm: envConfig.keycloakRealm,
    clientId: envConfig.keycloakClientId,
});

export default keycloak;